import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {onGetAccount, onUpdateAccount} from '../../../app/modules/accounts/core/_requests'
import { onGetGenders } from '../../../app/services/dataForComboBox/dataForComboBoxService'
interface AccountState {
  account: any,
  genders: any[],
}
const initialState = {
  account: null,
  genders: []
} as AccountState

export const fetchAccount = createAsyncThunk('account/fetchAccount', async () => {
  const data: any = await onGetAccount()
  return data.data.result
})

export const updateAccount = createAsyncThunk('account/updateAccount', async (param: any) => {
  const data: any = await onUpdateAccount(param)
  return data.data
})
export const fetchGenders = createAsyncThunk('address/fetchGenders', async () => {
  const data: any = await onGetGenders()
  return data.data.result
})

const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    clearAccount: (state) => {
      state.account = null
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAccount.fulfilled, (state: any, action) => {
      state.account = action.payload
    })
    builder.addCase(fetchGenders.fulfilled, (state: any, action) => {
      state.genders = action.payload.items
    })
  },
})

export const {clearAccount} = accountSlice.actions

export default accountSlice.reducer
